'use strict';

angular.module('imagetrend.components')
    .controller('hlpApplicationTypeController', ['$scope', 'ApplicationTypes', 'LicenseCategoryLevels', 'FBResponses', '$q', '$timeout', function ($scope, ApplicationTypes, LicenseCategoryLevels, FBResponses, $q, $timeout) {

        $scope.loading = true;
        $scope.typeLevels = {};
        $scope.typeLevel = {};
        $scope.vm = {};
        var isRenewal = false;
        var promises = [];
        $scope.typeOptions = [];
        $scope.hasLevels = false;

        if ($scope.defaultGroup) {
            $scope.defaultGroup.questions.forEach(function (question) {
                if (question.answer.data_point_code === 'certification_application_type')
                {
                    $scope.defaultApplicationType = question.answer.value;
                }
                else if (question.answer.data_point_code === 'certification_levels')
                {
                    $scope.defaultCertificationLevel = question.answer.value;
                }
            });
        }

        promises.push(ApplicationTypes.get($scope.parameters).then(function (types) {
            $scope.application_types = types;
        }))

        promises.push(LicenseCategoryLevels.get($scope.parameters).then(function (levels) {
            $scope.levels = levels;
        }))

        /*
        Business Logic surrounding Renewal option on form:
        - In order to see the Renewal option on the form, the applicant must have a current certification at the selected level.
        A "current" certification is one with a certification number recorded and an expiration date in the future.
        - So, a function below call a stored procedure 'getCertificationDataSetData'. The return record will satisfy the business
        logics above (cert number is not null and expiration date has not passed as well as the current levels).
        - After the function call. If exists, the $scope.certificationDataSet[0].certification_levels contains current cert levels
        in comma-separated format.
        - The useful function 'isLevelCurrent(level)' will check if the passing in level is one of the current levels. If it does and the
        application type is 'Renewal', then show the Renewal option on the form.
        */
        promises.push(FBResponses.getCertificationDataSetQuery(
            $scope.parameters.user_id || null,
            $scope.parameters.service_id || null,
            $scope.parameters.vehicle_id || null,
            $scope.parameters.default_license_category_id || null,
            $scope.parameters.license_request_id || null
        ).then(function (certificationDataSet) {
            $scope.certificationDataSet = certificationDataSet;
        }))

        $q.all(promises).then(function () {
            var typeID = null;

            $scope.application_types.forEach(function (type) {
                $scope.typeLevels[type.id] = [];
                $scope.levels.forEach(function (level) {
                    $scope.typeLevel[type.id + '%' + level.id] = false;
                })
            })

            if ($scope.group != null) {
                $scope.group.questions.forEach(function (question) {
                    if (question.data_point_code == 'certification_application_type') {
                        $scope.sprocValueFound = false;
                        var defaultValueFound = false;
                        var answerShowVal = '';
                        $scope.typeAnswerVal = '';
                        $scope.application_types.forEach(function (type) {
                            //If the applicant doesn't have a certification of that license category or have a expired certification (expiration is today or earlier) of that license category
                            //The application type radio button on the form should display the selected options under License > Details > Application Types except "Renewal"

                            //If the applicant has a valid certification (expiration date is later than today) of that license category
                            //The application type radio button on the form should display the selected options under License > Details > Application Types
                            //See TFS 161695
                            //See TFS 169096
                            // Take SPROC (getCertificationDataSetData) as priority, then default value 
                            if (!$scope.sprocValueFound && (question.default_value === type.name || type.id === question.answer.value)) {
                                typeID = type.id;
                                isRenewal = type.renewal;
                                answerShowVal = type.name;
                                $scope.typeAnswerVal = type.id;
                                $scope.vm.applicationTypeID = type.id;
                                $scope.vm.applicationTypeName = type.name;

                                if (question.default_value === type.name) {
                                    defaultValueFound = true;
                                }

                                if (question.answer.value === type.id && type.renewal) {
                                    $scope.sprocValueFound = true;
                                    $scope.renewalTypeId = question.answer.value;
                                }
                            }
                        });

                        // Clear Default or SPROC Value if it's not on the form or set it if it was found
                        if (!defaultValueFound && !$scope.sprocValueFound && question.default_value === question.answer.value) {
                            question.answer.show_value = null;
                            question.answer.value = null;
                        } else {
                            question.answer.show_value = answerShowVal;
                            question.answer.value = $scope.typeAnswerVal;
                        }
                    }
                    else if (question.data_point_code == 'certification_levels') {
                        $scope.hasLevels = true;
                        $scope.levelAnswerVal = question.answer.value;
                    }
                })

                $scope.group.questions.forEach(function (question) {
                    if (question.data_point_code == 'certification_levels' && question.answer.value != null) {
                        if (typeID != null) {
                            $scope.application_types.forEach(function (type) {
                                if (type.id == typeID) {
                                    question.answer.show_value = null;
                                    type.license_category_levels.forEach(function (l) {
                                        question.answer.value.split(',').forEach(function (v) {
                                            if (v == l.id) {
                                                $scope.typeLevels[typeID].push({ id: v });
                                                $scope.typeLevel[type.id + '%' + l.id] = true;
                                                if (question.answer.show_value == null) {
                                                    question.answer.show_value = l.name;
                                                }
                                                else {
                                                    question.answer.show_value += ', ' + l.name;
                                                }
                                            }
                                        })
                                    })
                                }
                            })
                        }
                        else {
                            question.answer.value = null;
                        }
                    }
                })

                if (!$scope.hasLevels) {
                    $scope.application_types.forEach(function (type) {
                        //If this is only Application Types data point, without certification levels attached, then Renewal should always be included.
                        //See DevOps 168875
                        $scope.typeOptions.push(type);
                    })
                }
            }
            else {
                $scope.typeOptions = $scope.application_types;

                if ($scope.component != null) {
                    $scope.component.questions.forEach(function (question) {
                        if (question.data_point_code == 'certification_levels') {
                            $scope.hasLevels = true;
                        }
                    })
                }
            }
            $scope.typeOptionsMapped = $scope.typeOptions.map(function (row) {
                return { has_levels: row.has_levels, id: row.id, label: row.label, license_category_levels: row.license_category_levels, name: row.label, renewal: row.renewal }
            })

            $scope.loading = false;
        })
        .catch(function (response) {
            // handle error
        });

        var isLevelCurrent = function (level) {
            if (!$scope.certificationDataSet || $scope.certificationDataSet.length === 0) {
                return false;
            }
            var levelIds = $scope.certificationDataSet[0].certification_levels.split(',');
            return levelIds.indexOf(level.id) !== -1;
        };

        $scope.showLevel = function (type, level) {
            var show = false;

            if (
                //see TFS 161695
                //initial is not the app type and renewal is the preselected choice
                //see TFS 169096
                //changed to show Initial bubble always
                (isRenewal) ||
                //renewal is not the app type and renewal is not the preselected choice
                (type.name !== 'Renewal' && !isRenewal) ||
                (type.name === 'Renewal' && isLevelCurrent(level)) ||
                //there is nothing in the group
                $scope.group == null) {
                type.license_category_levels.forEach(function (l) {
                    if (l.id == level.id) {
                        show = true;
                    }
                })
            }

            if ($scope.defaultCertificationLevel === level.id && $scope.defaultApplicationType === type.id) {
                show = true; // show old renewal value
            }

            return show;
        }

        $scope.typeChange = function (vm) {
            var timer = $timeout(function () {
                if ($scope.group != null) {
                    $scope.group.questions.forEach(function (question) {
                        if (question.data_point_code == 'certification_application_type') {
                            question.answer.value = vm.applicationTypeID;
                            question.answer.show_value = vm.applicationTypeName;
                        }
                    });
                }
            }, 0);

            $scope.$on('$destroy', function () {
                $timeout.cancel(timer);
            });
        }

        $scope.levelsChange = function (type, level) {
            for (var key in $scope.typeLevels) {
                // skip loop if the property is from prototype
                if (!$scope.typeLevels.hasOwnProperty(key)) continue;

                if (key == type.id) {
                    if ($scope.group != null) {
                        $scope.group.questions.forEach(function (question) {
                            if (question.data_point_code == 'certification_levels') {
                                question.answer.value = null;
                                question.answer.show_value = null;

                                if ($scope.isRequired) {
                                    question.answer.invalid = true;
                                    $scope.innerForm.$setValidity("required", false);
                                }

                                if (angular.isArray($scope.typeLevels[key])) {

                                    $scope.typeLevels[key].forEach(function (v) {
                                        question.answer.invalid = false;
                                        $scope.innerForm.$setValidity("required", true);

                                        if (question.answer.value == null) {
                                            question.answer.value = v.id;
                                        }
                                        else {
                                            question.answer.value += ',' + v.id;
                                        }
                                        if (question.answer.show_value == null) {
                                            question.answer.show_value = v.name;
                                        }
                                        else {
                                            question.answer.show_value += ', ' + v.name;
                                        }
                                    })
                                }
                            }
                            else if (question.data_point_code == 'certification_application_type') {
                                question.answer.value = key;
                                question.answer.show_value = type.name;
                            }
                        })
                    }
                }
                else {
                    $scope.typeLevels[key] = [];
                }

            }
        }

        $scope.validate = function () {
            // Does not have a group when building the form, but does when filling one out
            if ($scope.group !== undefined) {
                $scope.group.questions.forEach(function (question) {
                    if (question.data_point_code == 'certification_levels' || question.data_point_code == 'certification_application_type') {
                        if ($scope.isRequired && (question.answer.value == null && question.answer.show_value == null)) {
                            question.answer.invalid = true;
                            $scope.innerForm.$setValidity("required", false);
                        }
                        else {
                            question.answer.invalid = false;
                            $scope.innerForm.$setValidity("required", true);
                        }
                    }
                });
            }
        }

        $scope.levelChange = function (type, level) {
            for (var key in $scope.typeLevel) {
                // skip loop if the property is from prototype
                if (!$scope.typeLevel.hasOwnProperty(key)) continue;

                if (key != (type.id + '%' + level.id)) {
                    $scope.typeLevel[key] = false;
                }
            }

            if ($scope.group != null) {
                $scope.group.questions.forEach(function (question) {
                    if (question.data_point_code == 'certification_levels') {
                        question.answer.value = level.id;
                        question.answer.show_value = level.name;
                        $scope.levelAnswerVal = level.id;

                        question.answer.invalid = !isEmpty($scope.innerForm && $scope.innerForm.file && $scope.innerForm.file.$error);

                        if ($scope.isRequired && (question.answer.show_value == null && question.answer.value == null)) {
                            question.answer.invalid = true;
                        }
                    }
                    else if (question.data_point_code == 'certification_application_type') {
                        question.answer.value = type.id;
                        question.answer.show_value = type.name;
                        $scope.typeAnswerVal = type.id;
                    }
                })

                if ($scope.question !== undefined) {
                    $scope.question.answer.invalid = !isEmpty($scope.innerForm.file.$error);

                    if ($scope.isRequired && ($scope.question.answer.show_value == null && $scope.question.answer.value == null)) {
                        $scope.question.answer.invalid = true;
                    }
                }
            }
        }

        // This is extra code to help showLevels(), this will disable other renewal columns if renewal is returned by the SPROC or disable all of them if it's not returned at all
        $scope.hideRadioBtn = function (type, level) {

            var hide = false;

            // Helper function to check if level.id is in comma-separated levelAnswerVal
            var isLevelInAnswerVal = function () {
                if (!$scope.levelAnswerVal || $scope.levelAnswerVal.length === 0) {
                    return false;
                }
                var levelIds = $scope.levelAnswerVal.split(',');
                return levelIds.indexOf(level.id) !== -1;
            };

            // $scope.levelAnswerVal: from sproc 'certification_levels' answer value
            if ($scope.sprocValueFound && type.id === $scope.typeAnswerVal && isLevelInAnswerVal())
            {
                hide = false; // don't disable selected option
            }
            else if ($scope.defaultCertificationLevel === level.id && $scope.defaultApplicationType === type.id)
            {
                hide = false; // if answer was sproc, keep it on form after changing value 
            }
            else if (type.renewal && isLevelCurrent(level))
            {
                hide = false;
            }
            else if (type.renewal && !isLevelCurrent(level))
            {
                hide = true;
            }
            else if ($scope.sprocValueFound && type.id === $scope.typeAnswerVal && !isLevelInAnswerVal() && type.renewal)
            {
                hide = true; // disable the (renewal) column when renewal came from sproc
            }
            else if ($scope.sprocValueFound && $scope.renewalTypeId !== undefined && type.renewal)
            {
                hide = true; // disable the (renewal) column. This is a weird case, but prevent renewal from being selected when not from SPROC
            }

            return hide;
        }
    }])
    .directive('hlpApplicationType', ['$timeout', 'Format', 'Validation', function ($timeout, Format, Validation) {
        return {
            restrict: 'E',
            templateUrl: 'templates/application-type/application-type.html',
            replace: true,
            controller: 'hlpApplicationTypeController',
            scope: {
                parameters: '=?',
                checkboxOrRadio: '=?',
                group: '=?',
                component: '=?',
                defaultGroup: '=?',

                //attributes
                name: '@?',
                id: '@?',
                classes: '@?',
                modal: '@?',

                //disabled
                isDisabled: '=?',

                //required
                isRequired: '=?',
                showRequired: '=?',
                requiredText: '@?',

                //label
                showLabel: '@?',
                topLabel: '=?',
                label: '@?',
                title: '@?',

                //instructions
                instructions: '@?',
                showColon: '=?',
                pdf: '=?'
            },
            link: function (scope, elem, attrs, ctrl) {

                //attributes
                if (!attrs.id) { attrs.id = attrs.name; }
                if (!attrs.modal) { attrs.modal = false; } else { if (attrs.modal == 'true') { attrs.modal = true; } else { attrs.modal = false; } }

                //label
                if (!attrs.showLabel) { attrs.showLabel = true; } else { if (attrs.showLabel == 'true') { attrs.showLabel = true; } else { attrs.showLabel = false; } }
                if (!attrs.label) { attrs.label = Format.label(attrs.name); }
                if (!attrs.title) { attrs.title = attrs.label; }
                if (!attrs.topLabel) { attrs.topLabel = false; } else { if (attrs.topLabel == true || attrs.topLabel == 'true') { attrs.topLabel = true; } else { attrs.topLabel = false; } }
                if (!attrs.showColon) { attrs.showColon = true; } else { if (attrs.showColon == true || attrs.showColon == 'true') { attrs.showColon = true; } else { attrs.showColon = false; } }

                //required
                //if (!attrs.isRequired) { attrs.isRequired = false; } else { if (attrs.isRequired == 'true') { attrs.isRequired = true; } else { attrs.isRequired = false; } }
                if (!attrs.requiredText) { attrs.requiredText = 'Please enter a ' + attrs.label }

                scope.submitted = false;

                scope.$on('form:submit', function () {
                    scope.validate();
                    scope.submitted = true;
                });
            }
        };
    }])
    ;